import api from "./client";

export interface RecallCampaignVehicle {
  id: string;
  vin: string;
  plate: string;
  marque: string;
  modele: string;
  ordre_id?: string;
  dossier_id?: string;
  status: "detected" | "acknowledged" | "treated";
  detected_at: string;
}

export interface RecallCampaignGroup {
  campaign_code: string;
  campaign_title: string;
  total: number;
  treated: number;
  vehicles: RecallCampaignVehicle[];
}

export interface RecallCampaignEntry {
  id: string;
  campaign_code: string;
  campaign_title: string;
  status: "detected" | "acknowledged" | "treated";
  detected_at: string;
}

export const recallCampaignsApi = {
  listGrouped: async (orgId: string): Promise<RecallCampaignGroup[]> => {
    const { data } = await api.get("/recall-campaigns", {
      params: { org_id: orgId },
    });
    return data;
  },

  listForOrdre: async (ordreId: string): Promise<RecallCampaignEntry[]> => {
    const { data } = await api.get(
      `/recall-campaigns/ordre/${ordreId}`
    );
    return data;
  },

  updateStatus: async (
    campaignId: string,
    status: string
  ): Promise<RecallCampaignEntry> => {
    const { data } = await api.post(
      `/recall-campaigns/${campaignId}/status`,
      { status }
    );
    return data;
  },

  checkVin: async (
    orgId: string,
    vin: string,
    plate?: string,
    ordreId?: string
  ): Promise<{ code: string; libelle: string }[]> => {
    const { data } = await api.post("/recall-campaigns/check", {
      vin,
      plate: plate || "",
      ordre_id: ordreId,
    }, { params: { org_id: orgId } });
    return data;
  },
};
